import { init as initApm, ApmBase } from '@elastic/apm-rum';
import config from './config';

const apm: ApmBase = initApm({
  serviceName: config.apmServiceName,
  serverUrl: 'https://monitoring.bangkokdrugstore.co.th',
  environment: config.env,
  distributedTracingOrigins: [
    'https://mobile.bangkokdrugstore.co.th',
    'https://stg-mobile.bangkokdrugstore.co.th',
    'https://uat-mobile.bangkokdrugstore.co.th',
    'https://dev-mobile.bangkokdrugstore.co.th',
  ],
  transactionSampleRate: 1.0,
  active: config.env !== 'local',
});

export default apm;
